import { createAction, props } from '@ngrx/store';
import { MessageOutboxModel } from '@shared/data-access/models';

export const getDetail = createAction('[Message Outbox] GET DETAIL', props<{ item: MessageOutboxModel }>());
